import { Injectable } from '@angular/core';
import { HttpClient, HttpBackend } from '@angular/common/http';
import { Observable } from 'rxjs';

import { AuthenticationService } from './authentication.service';
import { FileService } from './file.service';

import { Email } from '@model/email.model';

import { environment } from '@environments/environment';

@Injectable({
  providedIn: 'root'
})
export class EmailService {
  constructor(private handler: HttpBackend, private authenticationService: AuthenticationService, private fileService: FileService) {}

  private http: HttpClient = new HttpClient(this.handler);

  sendEmail(email: Email): Observable<any> {
    const formData: FormData = this.fileService.createFormDataFile(email.attachFile, 'attachedFiles');

    formData.append('from', 'eTa-no-reply@gmail.com');
    formData.append('to', email.to);
    formData.append('cc', email.cc);
    formData.append('subject', email.subject);
    formData.append('content', email.content);
    formData.append('isSentFromAgent', email.isSentFromAgent.toString());

    const httpOptions: any = {
      headers: this.authenticationService.getHttpHeader(null)
    };

    const url: string = `${environment.endpoint}/email`;
    return this.http.post(url, formData, httpOptions);
  }
}
